<div class="col-12 pt-2" style="padding: 1rem">
  <div class="card">
    <div style="display: grid">
      <strong style="color: red">
        Negociação de {{ selectedOrders.length }} faturas no valor de
        {{ getTotalNegotiate() | number : "1.2-2" }}</strong
      >
    </div>
    <div class="mt-2">
      <div class="gap-2">
        <div class="pt-2">
          <span class="font-weight-bold pr-2 pl-2">Adicionar Taxas </span>
          <p-dropdown
            [options]="optionsProduct"
            [(ngModel)]="selectedTax"
            (onChange)="changeProduct($event)"
            placeholder="Selecione uma taxa"
            optionValue="value"
            optionLabel="label"
          ></p-dropdown>
          <span class="font-weight-bold pr-2 pl-2">Valor</span>

          <p-inputNumber
            [(ngModel)]="taxesValue"
            name="taxes"
            mode="decimal"
            [maxFractionDigits]="2"
            [minFractionDigits]="2"
            [disabled]="editValue"
            style="padding-right: 8px"
          >
          </p-inputNumber>

          <button
            pButton
            type="button"
            icon="pi pi-plus"
            (click)="addTaxes()"
          ></button>
        </div>
      </div>
      <div>
        <h2>Itens da Negociação</h2>
        <div class="table">
          <p-table
            #tt
            [value]="negotiateOrder.orderItems"
            [paginator]="false"
            autoLayout="true"
            styleClass="easy-table"
          >
            <ng-template pTemplate="caption">
              <div class="fill-empty"></div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th class="text-center">Item</th>
                <th class="text-center">Valor</th>
                <th class="text-center">Ações</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
              <tr>
                <td style="text-align: center">
                  {{ item?.product?.name }}
                </td>
                <td style="text-align: center">
                  {{ item?.totalValue | number : "1.2-2" }}
                </td>
                <td style="text-align: center">
                  <button
                    type="button"
                    pButton
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-danger p-button-sm"
                    (click)="removeOrderItem(rowIndex)"
                    [disabled]="rowIndex === 0"
                  ></button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="footer">
              <tr>
                <td colspan="7" style="text-align: right">
                  <div style="display: grid">
                    <strong style="text-align: right; color: red"
                      >Total de Débitos :
                      {{ getTotalPending() | number : "1.2-2" }}</strong
                    >

                    <strong class="pt-1" style="color: red">
                      + Total de juros e multas :
                      {{
                        getTotalPendingMoraAndMulta() | number : "1.2-2"
                      }}</strong
                    >
                    <strong class="pt-1" style="color: red">
                      + Outros serviços:
                      {{ getTotalOtherServices() | number : "1.2-2" }}</strong
                    >
                    <div
                      style="
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        gap: 8px;
                      "
                    >
                      <span class="font-weight-bold">Valor do Desconto:</span>
                      <p-inputNumber
                        [(ngModel)]="discountValue"
                        name="discountValue"
                        mode="decimal"
                        [maxFractionDigits]="2"
                        [minFractionDigits]="2"
                        (ngModelChange)="calcTotalToPayFinal()"
                        style="width: 80px"
                      >
                      </p-inputNumber>
                    </div>
                    <strong class="pt-1"
                      >Valor a Negociado :
                      {{ totalNegotiate | number : "1.2-2" }}</strong
                    >
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <div class="">
            <h4>Dados da Negociação</h4>
            <div class="pt-1">
              <!-- <label for="parcelas">Parcelas:&nbsp;</label>
              <input
                type="number"
                [(ngModel)]="parcels"
                name="parcelas"
                id="parcelas"
                style="text-align: center; max-width: 50px"
                pInputText
                min="1"
              />
              Valor da Parcela:&nbsp;
              <strong>
                {{ totalNegotiate / parcels | number : "1.2-2" }}
              </strong>
            </div> -->
            <div class="pt-1">
              <p-checkbox
                [(ngModel)]="personalDate"
                [binary]="true"
                label="Data vencimento do cliente"
              ></p-checkbox>
            </div>
            <div class="parcel flex25 pt-1" *ngIf="personalDate">
              <label for="valorParcela">Mês de Referência:&nbsp;</label>
              <p-dropdown
                [options]="monthsReference"
                [(ngModel)]="monthReferenceSelected"
                name="mesReferencia"
                id="mesReferencia"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione o mês de referência"
              ></p-dropdown>
              <label for="anoreferencia">Ano</label>
              <p-dropdown
                [options]="years"
                [(ngModel)]="yearSelected"
                name="yearReferencia"
                id="yearReferencia"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione o ano"
              ></p-dropdown>
            </div>
            <div class="parcel flex25 pt-1" *ngIf="!personalDate">
              <label [for]="'dataVencimento'">Vencimento</label>
              <p-calendar
                [(ngModel)]="duedate"
                [name]="'dataVencimento'"
                appendTo="body"
                [id]="'dataVencimento'"
                dateFormat="dd/mm/yy"
                required
                [showIcon]="true"
              >
              </p-calendar>
            </div>
            <!-- <div>
              <label for="billingPortfolioId"
                >Carteira de cobrança:&nbsp;</label
              >
              <p-dropdown
                [options]="billingPortifolioList"
                name="billingPortfolioId"
                appendTo="body"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="carteiraSelect"
              ></p-dropdown>
            </div> -->
            <div style="text-align: right">
              <button
                pButton
                type="button"
                icon="pi pi-check"
                (click)="negotiate()"
                label="Finalizar Negociação"
                [disabled]="totalNegotiate <= 0"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
